import React, { createContext, useContext } from "react"

import type { ThemeBottomSectionState } from "@/models/ITrackingPageOptions"

import type { ThemeLayoutBackdropEditorDraft } from "./themeLayoutBackdropEditor"

export interface BackdropThemeLayoutContextValue {
  draft: ThemeLayoutBackdropEditorDraft
  setDraft: React.Dispatch<React.SetStateAction<ThemeLayoutBackdropEditorDraft>>
  /** 弹窗编辑期间的预览 overlay，优先于 draft.content.bottom_section 用于右侧预览渲染；
   *  弹窗关闭后置 null，preview 回退到 store 数据。 */
  bottomSectionPopupDraft: ThemeBottomSectionState | null
  setBottomSectionPopupDraft: React.Dispatch<React.SetStateAction<ThemeBottomSectionState | null>>
}

const BackdropThemeLayoutContext = createContext<BackdropThemeLayoutContextValue | null>(null)

export const BackdropThemeLayoutProvider = BackdropThemeLayoutContext.Provider

export const useBackdropThemeLayout = (): BackdropThemeLayoutContextValue => {
  const v = useContext(BackdropThemeLayoutContext)

  if (!v) {
    throw new Error("useBackdropThemeLayout must be used within BackdropThemeLayoutProvider")
  }

  return v
}
